import Big from "big.js";
import { DiscountInput } from "./types";
import { DISCOUNT_TYPE } from "~served/configs/enums";

export function getDiscountAmount(
	amount: number,
	discount: UndefinedOrNull<DiscountInput>,
) {
	let discountAmount = 0;

	if (!discount?.type || !discount?.value) {
		discountAmount = 0;
	} else {
		if (discount?.type === DISCOUNT_TYPE.AMOUNT) {
			discountAmount = discount.value;
		}
		if (discount?.type === DISCOUNT_TYPE.PERCENTAGE)
			discountAmount = new Big(amount)
				.mul(discount.value)
				.div(100)
				.round(2)
				.toNumber();
	}

	discountAmount = getAmountWithinRange(0, discountAmount, amount);

	const discountedAmount = new Big(amount)
		.minus(discountAmount)
		.round(2)
		.toNumber();

	return {
		discountAmount,
		/** @deprecated for naming convention, use `discountedAmount` instead */
		amountAfterDiscount: discountedAmount,
		discountedAmount,
	};
}

export const getAmountWithinRange = (
	min: number,
	amount: number,
	max: number,
) => Math.min(Math.max(amount, min), max);
